module.exports = __webpack_public_path__ + "img/about-sponsor-1@2x.ec392cdb.png";